import { Select_Option_default } from "./chunk-OQ76FRTG.js";
import { Select_default } from "./chunk-CA27GZA3.js";

// src/elements/Select/index.ts
var SelectComponent = Select_default;
SelectComponent.Option = Select_Option_default;
SelectComponent.Option.displayName = "Select.Option";
export { SelectComponent };